export const assetMoveErrorCodes = {
  unProcessibleEntity: '422 Unprocessable Entity',
  ownerCodeRetrievalError: '514 Owner Code retrieval error',
  invalidOperationalEntity: 'INVALID_OPERATIONAL_ENTITY'
};
